import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const CTASection = ({ className }) => {
  return (
    <section className={cn('py-20 bg-red-600', className)}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Ready to Build Something Remarkable?
        </h2>
        <p className="text-lg text-red-100 max-w-2xl mx-auto mb-10">
          Partner with Redspire for engineering excellence, safety-first practices, 
          and infrastructure solutions that stand the test of time.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <Button
              size="lg"
              className="bg-white text-red-600 hover:bg-gray-100 px-8 group"
            >
              Start Your Project
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <Link to="/services">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white bg-transparent hover:bg-white/10 px-8"
            >
              Explore Services
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
